<script setup lang="ts">
import { useRandomOffersByLocation } from '~/composables/showcase'

const props = defineProps<{
  locationSlugId: string
}>()

const { data: offers, suspense: offersSuspense } = useRandomOffersByLocation(
  () => props.locationSlugId,
  1,
)

const offer = computed(() => offers.value?.[0])
const heroMultiLinkProps = useHeroMultiLink('offers_artists')

onServerPrefetch(async () => {
  await offersSuspense()
})
</script>

<template>
  <div class="flex flex-col gap-36">
    <AlOfferTeaser
      v-if="offer"
      :name="offer.name"
      :slug="`${offer.slug}-${offer.slug_id}`"
      :description="offer.description"
      :price="offer.price"
      :thumbnail="{
        src: offer.image_url,
        alt: offer.image_alt,
      }"
    />

    <AlHeroMultiLink v-bind="heroMultiLinkProps" />

    <AlMoreArtistsAndRegionsSection />
  </div>
</template>
